module.exports = __webpack_public_path__ + "static/media/HappyFace.30983cda.png";